import {
  getAvailabilitiesTableOptions,
  getCompaniesTableOptions,
  getComparablesTableOptions,
  getContactsTableOptions,
  getDealsTableOptions,
  getOccupiersTableOptions,
  getPipelinesTableOptions,
  getProjectsTableOptions,
  getPropertiesTableOptions,
  getRequirementsTableOptions,
  getSavedSetsTableOptions,
  getSignListTableOptions,
  getTableOptions,
  getEblastsTableOptions,
  getCustomRowsTableOptions,
  getMarketingTemplatesTableOptions,
  getDocumentsTableOptions,
} from '@/bundles/BaseTable/helpers/consts';

export const keys = ['occupier', 'company', 'availability', 'property',
  'comparable', 'deal', 'contact', 'requirement', 'project', 'pipeline', 'savedSet',
  'member', 'team', 'request', 'eblast', 'pressrelease', 'marketing', 'import', 'criticalDatesDashboardWidget', 'marketingTemplate',
  'marketingCampaign', 'customRow', 'signList', 'document'
];

export const tableOptionsDictionary = {
  company: () => getCompaniesTableOptions(),
  contact: () => getContactsTableOptions(),
  occupier: () => getOccupiersTableOptions(),
  requirement: () => getRequirementsTableOptions(),
  property: () => getPropertiesTableOptions(),
  availability: () => getAvailabilitiesTableOptions(),
  comparable: () => getComparablesTableOptions(),
  project: () => getProjectsTableOptions(),
  savedSet: () => getSavedSetsTableOptions(),
  deal: () => getDealsTableOptions(),
  pipeline: () => getPipelinesTableOptions(),
  signList: () => getSignListTableOptions(),
  eblast: () => getEblastsTableOptions(),
  customRow: () => getCustomRowsTableOptions(),
  marketingTemplate: () => getMarketingTemplatesTableOptions(),
  document: () => getDocumentsTableOptions(),
};

export const getInitialTableOptionsByType = (key) => {
  return key in tableOptionsDictionary ? tableOptionsDictionary[key]() : getTableOptions();
};

// Drops a persisted page size larger than the current max option.
export function sanitizeTableOptions (key, tableOptions) {
  const initial = getInitialTableOptionsByType(key);
  const maxItemsPerPage = Math.max(...initial.itemsPerPageOptions.map(({ value }) => value));
  const isOversized = tableOptions.itemsPerPage > maxItemsPerPage;

  return {
    ...tableOptions,
    itemsPerPageOptions: initial.itemsPerPageOptions,
    itemsPerPage: isOversized ? initial.itemsPerPage : tableOptions.itemsPerPage,
    page: isOversized ? 1 : tableOptions.page,
  };
}

export function tableOptionsStateBuilder () {
  const state = {};

  keys.forEach(key => {
    const tableOptions = getInitialTableOptionsByType(key);

    state[key] = {
      tableOptions,
      selected: []
    };
  });

  return state;
}
